import type {
	BasicCustomMailItemSendOptionalInput,
	BasicCustomMailItemSendRequiredInput,
	LangCode,
} from "@/lib/gql/__generated__/graphql";

import { QuestionEmailTemplateItemWithText } from "../../email-template/with-text";
import { QuestionEmailTemplateItemWithTextArea } from "../../email-template/with-text-area";

type Props = {
	label: string;
	dialogTitle?: string;
	textValue: string | undefined;
	textErrorMessage: string | undefined;
	handleChangeText: (input: string) => void;
	lang: LangCode;
	hotelEmailAddress?: string;
	sendTestEmail?: ({ lang, email }: { lang: LangCode; email: string }) => Promise<void>;
	hidePreviewButton?: boolean;
	isOverride: boolean;
	basicCustomMailSetting: BasicCustomMailItemSendRequiredInput | BasicCustomMailItemSendOptionalInput | undefined;
};

export const QuestionEmailTemplateItem = ({
	label,
	dialogTitle,
	textValue,
	textErrorMessage,
	handleChangeText,
	sendTestEmail,
	lang,
	hotelEmailAddress,
	hidePreviewButton = false,
	isOverride = false,
	basicCustomMailSetting,
}: Props) => {
	return (
		<>
			{isOverride ? (
				<QuestionEmailTemplateItemWithTextArea
					label={label}
					dialogTitle={dialogTitle}
					textValue={textValue}
					textErrorMessage={textErrorMessage}
					handleChangeText={handleChangeText}
					sendTestEmail={sendTestEmail}
					lang={lang}
					hotelEmailAddress={hotelEmailAddress}
					hidePreviewButton={hidePreviewButton}
					isOverride={isOverride}
				/>
			) : (
				<QuestionEmailTemplateItemWithText label={label} basicCustomMailSetting={basicCustomMailSetting} />
			)}
		</>
	);
};

QuestionEmailTemplateItem.displayName = "QuestionEmailTemplateItem";
